import { getField, updateField } from 'vuex-map-fields'
export const state = () => ({
  assistantId: null,
  workspaceActiveId: null // temporário por enquanto que o não efetivamente mudamos o id da workspace
})

export const getters = {
  workspaceActiveId (state) {
    return state.workspaceActiveId
  },
  getField
}

export const actions = {}

export const mutations = {
  updateField
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
